import { useEffect } from 'react'

import { useScript, getLocale } from '@pb/utils'
import { useSelector } from 'react-redux'

import appSelectors from 'App/duck/selectors'

const useKlarnaPostPurchase = (): any => {
  const klarnaScriptUrl = useSelector(appSelectors.getKlarnaPostPurchaseScriptUrl)
  const [loaded, error] = useScript(klarnaScriptUrl)

  useEffect(() => {
    if (loaded && !error) {
      // Klarna wants format en-GB and not en_gb
      const splitLocale = getLocale().split('_')
      const klarnaLocale = `${splitLocale[0]}-${splitLocale[1].toUpperCase()}`
      const klarnaPurchaseCountry = splitLocale[1].toUpperCase()

      Klarna.PostPurchaseExperience.init({
        locale: klarnaLocale,
        purchase_country: klarnaPurchaseCountry,
        design: 'hm',
      })
    }
  }, [loaded])

  return [loaded, error]
}

export default useKlarnaPostPurchase
